import { render, staticRenderFns } from "./FormMovimiento.vue?vue&type=template&id=24850cf0&scoped=true"
import script from "./FormMovimiento.vue?vue&type=script&lang=js"
export * from "./FormMovimiento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24850cf0",
  null
  
)

export default component.exports